export const environment = {
	production: true,
	codigoSistema: '0014',
	isMockEnabled: true, // You have to switch this, when your real back-end is done 
	timeToRefreshToken: 10000,

	/* RUTAS DE WEB SERVICES */
	//BaseUrlWS_IT: 'http://192.168.1.203:8005/WS_IT/api',
	//BaseUrlWS_IT: 'http://192.168.1.203:8005/WS_VT/api',
	//BaseUrlWS_IT: 'http://192.168.1.203:8005/WS_FT/api',
	// ws.danper.com:8983/

	BaseUrlWS_IT: 'https://campotrack-prd.camposol.com.pe:8082/WS_IT/api',
	BaseUrlWS_GCH: 'https://campotrack-prd.camposol.com.pe:8082/WS_GCH/api',
	BaseUrlWS_GI: 'https://campotrack-prd.camposol.com.pe:8082/WS_GI/api',
	BaseUrlWS_MM: 'https://campotrack-prd.camposol.com.pe:8082/WS_MM/api',
	BaseUrlWS_ADM: 'https://campotrack-prd.camposol.com.pe:8082/WS_ADM/api',
	BaseUrlWS_PS: 'https://campotrack-prd.camposol.com.pe:8082/WS_PS/api',
	BaseUrlWS_BC: 'https://campotrack-prd.camposol.com.pe:8082/WS_BC/api',
	BaseUrlWS_EL: 'https://campotrack-prd.camposol.com.pe:8082/WS_EL/api',
	
	// ws.danper.com:8983/

	/* USUARIOS AUTORIZADOS */
	apiUsernameIT: 'SysEvalDesWS_IT',
	apiUsernameGCH: 'SysEvalDesWS_GCH',
	apiUsernameGI: 'SysEvalDesWS_GI',
	apiUsernameMM: 'SysEvalDesWS_MM',
	apiUsernameADM: 'SysEvalDesWS_ADM',
	apiUsernameBC: 'SysEvalDesWS_BC',
	apiUsernameEL: 'SysEvalDesWS_EL',

	/* CONTRASELA DE USUARIOS AUTORIZADOS */
	apiPasswordIT: '975318642',
	apiPasswordGCH: '975318642',
	apiPasswordGI: '975318642',
	apiPasswordMM: '975318642',
	apiPasswordADM: '975318642',
	apiPasswordBC: '975318642',
	apiPasswordEL: '975318642',
};
